<template>
  <section class="portrait-upgrade">
    <div class="container">
      <div class="portrait-card">
        <div class="portrait-illustration">
          <img
            class="portrait-img"
            src="/assets/images/Individual Product Detail Page/Untitled_Artwork copy 1.png"
            alt="Animal Portrait"
          />
        </div>
        <div class="portrait-content">
          <p class="upgrade-eyebrow">ANIMAL PORTRAIT UPGRADE</p>
          <h2 class="upgrade-title">
            SEE YOUR PET AS<br />
            A CHARMING<br />
            LITTLE CHARACTER
          </h2>
          <p class="upgrade-desc">
            With our <span class="highlight">Animal Portrait</span> feature, transform your pet with a custom illustrated portrait — beautifully reimagined wearing charming
            outfits and full of personality.
          </p>
          <div class="price-badge-wrapper">
            <div class="price-badge">
              <span>Only $10<br />additional fee</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PortraitUpgradeBanner"
};
</script>

<style scoped>
.portrait-upgrade {
  background: #fffef9;
  padding: 60px 0;
  margin-top: 40px;
}

.portrait-card {
  display: flex;
  gap: 40px;
  align-items: center;
  background: #FFF0E5;
  border-radius: 20px;
  padding: 12px;
  border: 4px solid #FFFFFF;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03);
}

.portrait-illustration {
  position: relative;
  flex: 1;
  border-radius: 16px;
  overflow: hidden;
  /* Aspect ratio management */
  aspect-ratio: 4/3;
  background-color: #FFF0E5; 
}

.portrait-illustration .portrait-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.portrait-content {
  flex: 1;
  padding: 40px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.upgrade-eyebrow {
  font-family: "Jost", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 12px;
  color: #000;
  letter-spacing: 1px;
  margin-bottom: 12px;
  text-transform: uppercase;
}

.upgrade-title {
  font-family: "Jost", sans-serif;
  font-size: 36px;
  font-weight: 600;
  color: #e37267;
  text-transform: uppercase;
  line-height: 1.2;
  margin: 0 0 16px 0;
}

.upgrade-desc {
  color: #1a1a1a;
  font-size: 15px;
  line-height: 1.5;
  max-width: 400px; /* Limit width to leave room for badge on PC if side-by-side */
  margin-bottom: 0;
}

.highlight {
  color: #e37267;
  font-weight: 700;
}

.price-badge-wrapper {
  position: absolute;
  bottom: 30px;
  right: 30px;
  z-index: 2;
}

.price-badge {
  position: relative;
  width: 140px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e37267;
  font-weight: 700;
  text-align: center;
  padding: 20px;
  /* Use SVG data URI for the starburst shape */
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 150' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23FFFFFF' stroke='%23E37267' stroke-width='3' d='M100,5 L115,25 L140,20 L145,45 L170,55 L160,80 L180,100 L155,115 L160,140 L135,135 L120,155 L95,140 L75,160 L60,135 L35,145 L40,120 L15,110 L35,90 L20,65 L45,55 L40,30 L65,35 L80,10 Z' /%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

/* Remove the pseudo-element hack */
.price-badge::before {
  display: none;
}

.price-badge span {
  font-size: 13px;
  line-height: 1.3;
  transform: rotate(-3deg);
}

@media (max-width: 1200px) {
  .portrait-illustration {
    aspect-ratio: 16/9;
  }
}

@media (max-width: 768px) {
  .portrait-card {
    flex-direction: column;
    padding: 12px;
    gap: 12px;
    border-radius: 16px;
  }

  .portrait-illustration {
    width: 100%;
    aspect-ratio: 1 / 0.85;
    min-height: unset;
  }

  .portrait-content {
    padding: 10px 10px 60px 10px; /* Bottom padding for badge */
    width: 100%;
  }

  .upgrade-title {
    font-size: 26px;
  }
  
  .upgrade-desc {
    max-width: 100%;
  }

  .price-badge-wrapper {
     bottom: 10px;
     right: 0px;
  }
  
  .price-badge {
    width: 120px;
    height: 86px;
    padding: 16px;
  }
  
  .price-badge span {
    font-size: 11px;
  }
}
</style>

